import TableContainer from "components/Common/DataTableContainer"
import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { downloadBalanceReport } from "../../../redux/actions/pvs"
import { Button } from "reactstrap"
import ConfirmPopup from "components/ConfirmPopup"
import ErrorPopup from "components/ErrorPopup"
import {
  DOWNLOAD_BALANCE_REPORT_RESET,    
} from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import PageLoader from "components/Common/PageLoader"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const BalanceReport = () => {
  document.title = "Balance Report | PULA"

  const query = useQuery()
  const combineGroupId = query.get("id")

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [paymentStatistic, setPaymentStatistic] = useState(null)

  const token = useSelector(state => state.auth.token)
  const balanceReport = useSelector(state => state.pvs.balanceReport)
  const paymentStatistics = useSelector(state => state.pvs.paymentStatistics)
  const balanceReportFileLink = useSelector(
    state => state.pvs.balanceReportFileLink
  )
  const downloadBalanceReportScreen = useSelector(
    state => state.screens.pvs.downloadBalanceReport
  )

  useEffect(() => {
    dispatch({ type: DOWNLOAD_BALANCE_REPORT_RESET })
    fetchReport("list")
  }, [])

  useEffect(() => {
    if (downloadBalanceReportScreen.success) {
      if (balanceReportFileLink) {
        const link = document.createElement("a")
        link.href = balanceReportFileLink
        link.download = "balance-report.zip"
        link.click()
      }
      dispatch({ type: DOWNLOAD_BALANCE_REPORT_RESET })
    }
    if (downloadBalanceReportScreen.error) {
      toast.error(downloadBalanceReportScreen.error)
      dispatch({ type: DOWNLOAD_BALANCE_REPORT_RESET })
    }
  }, [downloadBalanceReportScreen])

  useEffect(() => {
    const paymentStatistic = paymentStatistics.find(
      p => p.enc_combine_group_id === combineGroupId
    )
    setPaymentStatistic(paymentStatistic)
  }, [paymentStatistics])

  const fetchReport = type => {
    dispatch(
      downloadBalanceReport(
        {
          enc_combine_group_id: combineGroupId,
          report_type: type, //list , excel
        },
        token
      )
    )
  }

  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "payment_date",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Stall No",
        accessorKey: "stall_no",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Cash",
        accessorKey: "cash",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Bank Transfer",
        accessorKey: "bank_transfer",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "UPI",
        accessorKey: "upi",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Transaction ID",
        accessorKey: "transaction_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Status",
        accessorKey: "payment_status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span
              className={`badge ${
                value === "Paid"
                  ? "bg-success"
                  : value === "Pending"
                  ? "bg-warning"
                  : "bg-danger"
              }`}
            >
              {value}
            </span>
          )
        },
      },
    ],
    [navigate]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">{`${paymentStatistic?.bazaar_name}`}</h4>
          </div>

          <Button
            color="primary"
            onClick={() => {
              fetchReport("excel")
            }}
          >
            Download report
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={balanceReport || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
      {/* <PageLoader open={getPaymentStatisticsScreen.loading} /> */}
    </div>
  )
}

export default BalanceReport
